import { ReportDefinitions, UserReportInput } from 'generated/graphql-types';
export interface UserReportViewModel {
   userId: number;
   userReportId: number;
   reportId: ReportDefinitions;
}
export interface UserReportItemView {
   userReportId: number;
   userId: number;
   reportId: ReportDefinitions;
   isDeleted: boolean;
}

export const userReportsFields: (keyof UserReportInput)[] = ['reportId', 'userId'];
